import { getProblemExecutorsApi } from '@/core/api/generatedApiClient';
import { INLINE_API_ERROR_OPTIONS } from '@/core/api/requestErrorMode';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { GetProblemExecutorsResponse, ProblemExecutorsApiGetProblemExecutorsRequest } from '@/core/generated/api';

/** Загружает отзывы для контроля качества исполнителей */
export const problemExecutorService = {
    /** Получает страницу отзывов с оценками от одной до трёх звёзд */
    async getList(
        query: ProblemExecutorsApiGetProblemExecutorsRequest
    ): Promise<GetProblemExecutorsResponse> {
        try {
            const response = await getProblemExecutorsApi().getProblemExecutors(query, INLINE_API_ERROR_OPTIONS);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },
};

